import { Injectable } from '@angular/core';
import { AttachDetachStepperModel } from '../model/attach-detach-step-model';

@Injectable({
  providedIn: 'root'
})
export class TransportAttachDetachStepperService {

  stepperModel: AttachDetachStepperModel = new AttachDetachStepperModel();

  constructor() { }

  public setStepperModel(stepperModel: AttachDetachStepperModel) {
    this.stepperModel = stepperModel;
  }
}
